import { clientInfo } from 'configureBrand'

const determineCplErrorType = (): string => {
  return clientInfo.hasCplOldErrorCode ? 'oldErrorCode' : 'newErrorCode'
}

export default determineCplErrorType
